module.exports = __webpack_public_path__ + "img/bg-form-lower-mobile.1024f5f8.png";